import React from 'react';
import styles from './DirectSpeech.module.scss'
import JpgGladkov from './../../images/gladkov.jpg'

const DirectSpeech = () => {
    return (
        <div className={styles.container}>
            <div className={styles.imgContainer}>
                <img className={styles.img} src={JpgGladkov} alt=" Вячеслав Гладков"/>
            </div>
            <div className={styles.textBlock}>
                <div className={styles.textContainer}>
                    <h3 className={styles.boldText}>Дорогие жители Белгородчины, наши доблестные Защитники
                        Отечества!</h3>
                    <div className={styles.text}>
                        <p>
                            Рад приветствовать вас на информационном ресурсе регионального проекта «СТАЛЬ». Он создан в
                            поддержку наших мужественных воинов, отдавших силы защите Родины. Сегодня наша главная
                            задача – помочь ветеранам специальной военной операции обрести новые возможности для
                            служения своей малой родине, будь то работа в органах государственной и муниципальной
                            власти, общественных организациях или бизнесе.
                        </p>
                        <p className={styles.text}>
                            Программа сформирована для участников и ветеранов СВО, готовых получить необходимые знания,
                            чтобы пополнить кадровый резерв Белгородской области. Уверен, что выпускники проекта внесут
                            значимый вклад в развитие нашего региона, укрепят управленческую команду и станут примером
                            служения народу и государству!
                        </p>
                        <p>Вместе – к процветанию Белгородчины! Вместе – к сильной России!</p>
                    </div>
                </div>

                <div className={styles.nameBlock}>
                    <p className={styles.name}>Губернатор Белгородской области</p>
                    <span className={styles.boldText}>
                        Вячеслав Гладков
                    </span>
                </div>
            </div>
        </div>
    )
};

export default DirectSpeech;